module.exports = __webpack_public_path__ + "media/images/talent/mv-02-9aa53493c2903a234091953dbb4b42af.png";